// Include jQuery
const $ = require('jquery');

// jQuery Definitionen
window.jQuery = $;
window.$ = $;

require('../vendor/html5shiv.min');
require('../vendor/jquery-mpfader');
require('../vendor/jquery-zoombox.min');
require('./functions');

// Document Ready
$(function() {
  // CSS-Klasse wechseln, wenn JS aktiviert ist (für Fallbacks)
  $('html:first').removeClass('no-js').addClass('js');

  // Zoombox
  $('.zoombox').zoombox();

  // Set cache = false for all jquery ajax requests.
  $.ajaxSetup({
    cache: false,
  });

  $('#download-list').find('input[type="checkbox"]').on('change', function() {
    checkData();
  });

  // Slider Referenzen: Klasse load hinzufuegen
  var faderReference = $('#fader-reference');
  faderReference.addClass('load').prev('div.loader-holder').addClass('active');

  // iFrame Google Maps erst zoombar nach Klick
  googleMapsIframe();

  // Artikelbezeichnung in Kachelansicht soll bei allen Elementen gleich hoch sein
  oneHeight();

  $('.csc-mailform').mpAjaxForm();

  $('.accordion .accordion-click').click(function() {
    if (!$(this).hasClass('active')) {
      var accordion = $('.accordion');
      accordion.children('.accordion-click.active').siblings('.accordion-content').slideUp(300);
      accordion.children('.accordion-click.active').removeClass('active');
    }

    $(this).toggleClass('active');
    $(this).siblings('.accordion-content').slideToggle(300);
  });

  // Responsive Nav Open/Close
  $('#responsive-menu').click(function() {
    openResponsiveNavigation();
  });
  $('#js-overlay, #close-responsive-menu').click(function() {
    closeResponsiveNavigation();
  });
  $('#responsive-navigation-outer').click(function(event) {
    if ($(event.target).attr('id') === 'responsive-navigation-outer') {
      closeResponsiveNavigation();
    }
  });

  // Onepage Scroll
  $('.onepage-click').click(function(e) {
    e.preventDefault();
    var ele = $(this).data('id');
    var headerHeight = $('#header').outerHeight();

    $('html,body').animate({
      scrollTop: $('#op-section-' + ele).offset().top - headerHeight,
    }, 300);
  });

  if (window.location.hash !== '') {
    var headerHeight = $('#header').outerHeight();
    $('html,body').animate({
      scrollTop: $(window.location.hash).offset().top - headerHeight,
    }, 300);
  }

  updateSectionMenu();

  // mpfader init
  $('#fader').mpfader({
    keyNavigation: true,
    effect: 'slide-x',
  });

  $('#fader-01').mpfader({
    keyNavigation: false,
    effect: 'slide-x',
    buttonPage: '.fader-page_01',
  });

  $('#fader-02').mpfader({
    keyNavigation: false,
    effect: 'slide-x',
    buttonPage: '.fader-page_02',
  });

  faderReference.mpfader({
    keyNavigation: true,
    effect: 'slide-x',
    buttonPage: '.fader-page_reference',
  });

  $('.fader-more').click(function() {
    var headerHeight = $('#header').outerHeight();
    // content
    $('html,body').animate({
      scrollTop: $('#content').offset().top - headerHeight,
    }, 300);
  });

  $('#beleuchtungsstaerke').on('change', function() {
    if ($(this).is(':checked')) {
      $('#calc-gewuenschte-beleuchtungsstaerke').hide();
      $('#button-beleuchtungsstaerke').removeAttr('disabled');

      $('#calc-anzahl-leuchten').show();
      $('#button-anzahlLeuchten').attr('disabled', 'disabled');
    } else {
      $('#calc-gewuenschte-beleuchtungsstaerke').show();
      $('#button-beleuchtungsstaerke').attr('disabled', 'disabled');

      $('#calc-anzahl-leuchten').hide();
      $('#button-anzahlLeuchten').removeAttr('disabled');
    }
  });

  $('#anzahlLeuchten').on('change', function() {
    if ($(this).is(':checked')) {
      $('#calc-gewuenschte-beleuchtungsstaerke').show();
      $('#button-anzahlLeuchten').removeAttr('disabled');

      $('#calc-anzahl-leuchten').hide();
      $('#button-beleuchtungsstaerke').attr('disabled', 'disabled');

    } else {
      $('#calc-anzahl-leuchten').show();
      $('#button-beleuchtungsstaerke').removeAttr('disabled');

      $('#calc-gewuenschte-beleuchtungsstaerke').hide();
      $('#button-anzahlLeuchten').attr('disabled', 'disabled');
    }
  });

  $(window).scroll(function() {
    if ($(window).scrollTop() > 100) {
      $('.scroll-top').css('opacity', '0.5');
    } else {
      $('.scroll-top').css('opacity', '0');
    }
  });

  $('.scroll-top').click(function() {
    $('html,body').animate({
      scrollTop: $('html').offset().top,
    }, 300);
  });

  headerAbstand();
});

$(window).scroll(function() {
  updateSectionMenu();
});

$(window).resize(function() {
  headerAbstand();
  oneHeight();
  updateSectionMenu();

  if ($(window).width() > 996) {
    closeResponsiveNavigation();
  }
});

$(window).on('load', function() {
  // Referenz-Slider einfaden wenn fertig geladen
  setTimeout(function() {
    $('#fader-reference').removeClass('load').prev('div.loader-holder').removeClass('active');
  }, 1500);
});
